import { Button } from '../ui'
import FragranceImage from '../collection/FragranceImage'

function concentrationLabel(fragrance) {
  const conc = fragrance.concentration || fragrance.concentrations?.[0] || ''
  if (!conc || conc.toLowerCase() === 'unknown') return ''
  return conc
}

export default function ConcentrationPickerSheet({ open, onClose, line, onSelect }) {
  if (!open || !line) return null

  return (
    <>
      <div
        role="presentation"
        onClick={onClose}
        className="fixed inset-0 z-40 bg-black/60 backdrop-blur-sm animate-fade-in"
      />
      <div className="fixed inset-x-0 bottom-0 z-50 max-h-[80vh] overflow-y-auto rounded-t-2xl border-t border-gold/30 bg-charcoal-800 pb-safe animate-slide-up">
        <div className="sticky top-0 z-10 flex items-center justify-between border-b border-white/10 bg-charcoal-800 px-4 py-3">
          <div className="min-w-0 flex-1">
            <h3 className="font-body text-base font-semibold text-cream">{line.name}</h3>
            <p className="text-xs text-cream/40">{line.house}</p>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="ml-2 flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-cream/60 hover:bg-white/10"
            aria-label="Close"
          >
            ✕
          </button>
        </div>

        <div className="px-4 py-2">
          <p className="text-xs text-cream/45">Choose which concentration to wear:</p>
        </div>

        <div className="space-y-0">
          {line.variants.map(variant => {
            const label = concentrationLabel(variant)
            return (
              <button
                key={variant.id}
                type="button"
                onClick={() => {
                  onSelect(variant)
                  onClose()
                }}
                className="flex w-full items-center gap-3 border-b border-white/5 px-4 py-3 text-left transition-colors hover:bg-white/5 active:bg-white/10 last:border-b-0"
              >
                <div className="w-12 shrink-0">
                  <FragranceImage fragrance={variant} />
                </div>
                <div className="min-w-0 flex-1">
                  <p className="text-sm font-medium text-cream">
                    {label || 'Standard'}
                  </p>
                  {variant.sizes && variant.sizes.length > 0 && (
                    <p className="text-xs text-cream/40">
                      {variant.sizes
                        .filter(s => s.ml)
                        .map(s => `${s.ml}ml`)
                        .join(', ')}
                    </p>
                  )}
                </div>
                <span className="text-gold" aria-hidden>→</span>
              </button>
            )
          })}
        </div>
      </div>
    </>
  )
}
